// tslint:disable
export enum AgencyType {
    /**
     * @description National Home Health Agency
     */
    NatlHealthAgncy = 59,
    /**
     * @description Independent Home Health Agency
     */
    IndlHealthAgncy = 60,
    /**
     * @description Per Diem/Contract Individual
     */
    PDCI = 62,
}
(AgencyType as any)['NATLHEALTHAGNCY'] = 59;
(AgencyType as any)['INDLHEALTHAGNCY'] = 60;
